import { render } from "./Home.vue?vue&type=template&id=6a63e488"
import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a63e488"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a63e488', __exports__)) {
    api.reload('6a63e488', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=6a63e488", () => {
    api.rerender('6a63e488', render)
  })

}


export default __exports__